import { FC, useEffect, useRef, useState } from "react"
import { DiaryRow } from "./types"
import { IDictionary } from "shared/types"
import TagItem from '@atomaro/ui-kit/components/Tag/TagItem/TagItem';
import { TableDictionariesWrapper } from "./styles";
import { useResize } from "app/lib/hooks/useResize";
import { useDebounceCallback } from "shared/lib/debounce/useDebounce";

type DiaryDictionariesCellProps = {
  row: DiaryRow
}
export const DiaryDictionariesCell: FC<DiaryDictionariesCellProps> = ({
  row
}) => {
  const { width } = useResize();
  const [ dictionaries, setDictionaries ] = useState<IDictionary[]>([]);
  const [ visibleDictionaries, setVisibleDictionaries ] = useState<string[]>([]);

  const wrapper = useRef<HTMLDivElement | null>(null);
  
  useEffect(() => {
    setDictionaries(row.dictionaries);
  }, [row])

  const setVisibleDictionariesAction = useDebounceCallback(() => {
    if (!wrapper.current) return;

    const maxWidth = wrapper.current?.offsetWidth - 40;
    const names = dictionaries.map(el=>el.name);
    const arr = [];

    const div = document.createElement('div');
    document.body.append(div);

    let spansWidth = 0;
    let plus = dictionaries.length;
    for (let index = 0; index < names.length; index++) {
      const name = names[index];
      const span = document.createElement('span');
      span.style.setProperty('padding', '0px 6px');
      span.innerHTML = name;

      div.append(span);
      spansWidth += (span.offsetWidth + 4);
      
      if (spansWidth < maxWidth) {
        arr.push(name);
        plus--;
      } else {
        arr.push(`+${plus}`)
        break;
      }
    }

    div.remove();
    setVisibleDictionaries(arr);
  }, 500);

  useEffect(() => {
    if (wrapper.current&&dictionaries.length) {
      setVisibleDictionariesAction();
    }
  }, [width, wrapper, dictionaries])

  if (!dictionaries.length) {
    return <>-</>
  }

  return (
    <TableDictionariesWrapper ref={wrapper}>
      {visibleDictionaries.map(dictionary => (
        <TagItem size="s">
          {dictionary}
        </TagItem>
      ))}
    </TableDictionariesWrapper>
  )
}